module.exports = __webpack_public_path__ + "static/media/iguazu-falls-23.7644602f.jpg";